import { useState } from 'react';
import styled from 'styled-components';
import Profile from '../Profile';
import ChangePassword from '../ChangePassword';
import { CredusText, color } from 'ui';

const AccountSettingsTab = () => {
  const [tabValue, setTabValue] = useState<number>(0);

  const tab = ['Profile', 'Change Password'];
  const handleChangeTab = (item: number) => () => setTabValue(item);
  const tabContent = [<Profile />, <ChangePassword />];
  return (
    <div>
      <HeaderDiv>
        {tab.map((item, i) => (
          <TabButton
            bg={tabValue === i ? 'rgba(252, 57, 29, 0.04)' : '#fff'}
            key={i}
            onClick={handleChangeTab(i)}
          >
            <CredusText
              color={tabValue === i ? color.primary : color.black}
              size="md"
              weight="medium"
            >
              {item}
            </CredusText>
          </TabButton>
        ))}
      </HeaderDiv>

      <>{tabContent[tabValue]}</>
    </div>
  );
};

export default AccountSettingsTab;

const TabButton = styled.div<{ bg: string }>`
  padding: 11px 23px;
  background: ${({ bg }) => bg};
  cursor: pointer;
  transition: all 0.35s ease-in-out;
  &:hover {
    background: rgba(252, 57, 29, 0.04);
  }
`;

const HeaderDiv = styled.div`
  margin-bottom: 3.125rem;
  display: flex;
  gap: 7px;
  align-items: center;
  justify-content: center;
`;
